<template>
  <div class="diagnosticReports">
    <div class="row">
      <div class="col-md-12">
        <router-link
          class="ui-back-action"
          :to="{ name: 'ListDiagnostic' }"
        >
          <i class="fas fa-chevron-left"></i>
          {{ $t("global.back") }}
        </router-link>
      </div>
    </div>
    <div class="diagnosticReports__header">
      <h1>{{ $t("surveys.newSurvey.details") }} {{ this.$route.params.surveyObj.name }}</h1>
      <button
        @click="downloadExcel"
        class="ui-action-button"
        :disabled="isDownloading"
      >
        {{ $t("surveys.newSurvey.download") }} .xlsx
        <b-spinner class="ml-1" small label="loading" v-if="isDownloading"></b-spinner>
      </button>
    </div>
    <div class="row">
      <div
        class="diagnosticReports__graph-container col-md-6 col-sm-12"
        v-for="pieChart in pieCharts"
        :key="pieChart.id"
      >
        <apexchart type="pie" height="250" :id="pieChart.id" :options="pieChart" :series="pieChart.series"></apexchart>
      </div>
      <div  class="diagnosticReports__graph-container col-md-12 col-sm-12 mt-5">
        <!-- pie charts -->
         <h3>Categorias</h3>
         <apexchart v-if="mostrar" type="bar" height="500" :options="chartOptions2" :series="series3" />
      </div>
      <div class="diagnosticReports__table" :key="reportsKey">
        <v-client-table
          class="ui-table"
          :columns="table_options.columns"
          :options="table_options.options"
          :data="tableData"
        ></v-client-table>
      </div>
    </div>
  </div>
</template>

<script>
import API_SERVICE_DIAGNOSTIC from "@/lib/api/Diagnostic.js";
const api_diagnostic = new API_SERVICE_DIAGNOSTIC();

export default {
  data() {
    return {
      mostrar: false,
      categorias: [],
      valores: [],
      series3 :[
        {
          name: 'Puntaje 5',
          data: []
        },
        {
          name: 'Puntaje 4',
          data: []
        },
        {
          name: 'Puntaje 3',
          data: []
        },
        {
          name: 'Puntaje 2',
          data: []
        },
        {
          name: 'Puntaje 1',
          data: []
        }
      ],

      chartOptions2:{
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom'
            }
          }
        }],
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          categories: [],


        },
        colors: ["#008223", "#3FCF2C", "#FFC300", "#FF5733", "#B22222"],
        yaxis: {
          labels: {
            style: {
              fontSize: '13.5px' // Eje X
            }
          }
        },
        legend: {
          position: 'right',
          offsetY: 40,
          fontSize: '17px'
        },
        fill: {
          opacity: 1
        },
        dataLabels: {

          style: {
            fontSize: '17px' // Etiquetas de datos
          }
        },
      },
      options: {
        chart: {
          toolbar: {
            show: true
          },
          height: 200,
          type: "line",
          stacked: false,
          zoom: {
            enabled: false
          },
        },
        colors: ["#008223", "#3FCF2C", "#FFC300", "#FF5733", "#B22222"],

        xaxis: {
          categories: []
        },
        yaxis: [
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: "black"
            },
            labels: {
              style: {
                colors: "black"
              }
            },
            title: {
              text: "Grafica de categorias",
              style: {
                color: "black",
                
              }
            }
          },
          {
            opposite: true,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: "black"
            },
            labels: {
              style: {
                colors: "black"
              }
            },

          }
        ],


      },
      series: [
       
      ],
      reportsKey: new Date().getTime(),
      isDownloading: false,
      report: {}, // renspose from API
      pieCharts: [],
      tableData: [],
      basicColumns: [
        'uo',
        'uoDescription',
        'idUo',
        'directBossControlNumber',
        'gender',
        'status',
        'type',
        'typeDescription',
        'workingShift',
        'dailyWorkingShift',
        'substitutionWorkingShift',
        'maritalStatus',
        'numberOfChildren'
      ],
      tableColumns: []
    };
  },
  async mounted() {
    this.tableColumns = [...this.basicColumns]
    await this.getReport();
    await this.buildGraphs(this.report);
  },
  computed: {
    pieChartOptions() {
      return {
        chart: {
          width: "100%",
          type: "pie",
        },
        labels: [],
        colors: ["#333333", "#d9d9d9"],
        states: {
          hover: {
            filter: {
              type: "none",
            }
          }
        }
      };
    },
    table_options() {
      return {
        columns: this.tableColumns,
        options: {
          filterable: false,
          columnsDropdown: true,
          filterByColumn: false,
          resizableColumns: false,
          perPage: 10,
          headings: this.tableColumns.reduce((acc, col) => {
            acc[col] = this.basicColumns.includes(col)
              ? this.$t(`users.manage.table.headings.${col}`)
              : col
            return acc;
          }, {})
        }
      }
    }
  },
  methods: {
    async getReport() {
      try {
        this.$store.commit("global/SET_LOADING", true);
        const response = await api_diagnostic.getReport(this.$route.params.surveyObj.id)
        if (response && response.data) {
          this.report = response.data;
          this.getTableData();
          this.getTableCategory();
          this.reportsKey = new Date().getTime()
        } else {
          throw new TypeError("no data availiable");
        }
      } catch (error) {
        console.error(error);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('diagnostic.report.getError'),
          show: true,
          type: "error"
        });
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    getTableCategory(){
            const response=this.report;
            let objeto={};
            for(let i=0;i <response.answers.length;i++){
              for(let ii=0;ii <response.answers[i].questions.length;ii++){
                if(response.answers[i].questions[ii]["questionType"]=="number" && response.answers[i].questions[ii]["answer"]!=null){
                  response.answers[i].questions[ii]["answer"]=response.answers[i].questions[ii]["answer"] | 0;
                if(objeto.hasOwnProperty(response.answers[i].questions[ii].categoryName) && objeto[response.answers[i].questions[ii].categoryName].cantidad){
                  objeto[response.answers[i].questions[ii].categoryName]={cantidad:[...objeto[response.answers[i].questions[ii].categoryName].cantidad,response.answers[i].questions[ii].answer],nombre:response.answers[i].questions[ii].categoryName}
              
              }else{
                objeto[response.answers[i].questions[ii].categoryName]={cantidad:[response.answers[i].questions[ii].answer],nombre:response.answers[i].questions[ii].categoryName}
              }
            }
              }
            }
            
            for (var key1 in objeto) {
              const datos = objeto[key1].cantidad.length === 1? [...objeto[key1].cantidad, ...objeto[key1].cantidad] : objeto[key1].cantidad
              const promedio = (datos.reduce((acc, val) => acc + val, 0) / datos.length).toFixed(2);
    
              this.categorias.push(objeto[key1].nombre);
              //this.valores.push(JSON.parse(JSON.stringify({name:key1,data:objeto[key1].cantidad.length==1 ? [...objeto[key1].cantidad,...objeto[key1].cantidad] :objeto[key1].cantidad })));
              this.valores.push({ name: `${key1} (Promedio: ${promedio})`,data: datos});
  
            }
      const valoresFinales = JSON.parse(JSON.stringify(this.valores));

      let categoriasUni = [];
      let contador = 5;
      for (let index = 0; index < valoresFinales.length; index++) {
        categoriasUni = [...categoriasUni, valoresFinales[index].name]
        this.series3[0].data = [...this.series3[0].data, valoresFinales[index].data.filter(num => num === 5).length];
        this.series3[1].data = [...this.series3[1].data, valoresFinales[index].data.filter(num => num === 4).length];
        this.series3[2].data = [...this.series3[2].data, valoresFinales[index].data.filter(num => num === 3).length];
        this.series3[3].data = [...this.series3[3].data, valoresFinales[index].data.filter(num => num === 2).length];
        this.series3[4].data = [...this.series3[4].data, valoresFinales[index].data.filter(num => num === 1).length];



      }



      this.chartOptions2.xaxis.categories = categoriasUni;
            //this.categorias=Array.from(this.categorias);
            //this.valores=Array.from(this.valores);
            //this.options.xaxis.categories=this.categorias;
            this.options.xaxis.categories=this.categorias;
            this.series=JSON.parse(JSON.stringify(this.valores));
            this.mostrar=true;
    },
    getTableData () {
      const report = { ...this.report }
      const answers = report && report.answers && report.answers.length
        ? report.answers
        : []
      const tableData = answers.map(answer => {
        const questions = answer.questions && answer.questions.length
          ? answer.questions
          : []
        questions.forEach((question, index) => {
          const headerQuestion = question.question
          if (!this.tableColumns.includes(headerQuestion)) {
            this.tableColumns.push(headerQuestion)
          }
          answer[headerQuestion] = question.answer === null
            ? this.$t('diagnostic.report.notAnswered')
            : question.answer
        })

        return {
          ...answer
        }
      });

      this.tableData = tableData;
    },
    buildGraphs(report) {
      const answered = report.answered || { answers: 0, notAnswered: 0 };
      this.pieCharts.push({
        ...this.pieChartOptions,
        id: "answeredChart",
        title: { text: this.$t("diagnostic.graphs.participation") },
        labels: [
          this.$t("diagnostic.graphs.participated"),
          this.$t("diagnostic.graphs.nonParticipated"),
        ],
        series: [+answered.answers, +answered.notAnswered],
      });

      const status = report.status || { completed: 0, notAnswered: 0 };
      this.pieCharts.push({
        ...this.pieChartOptions,
        id: "statusChart",
        title: { text: this.$t("diagnostic.graphs.status") },
        labels: [
          "No contestadas",
          "Parcialmente contestadas",
        ],
        colors: ["#333333", "#bb0a30"],
        //series: [+status.completed, +status.notAnswered],
        series: [parseInt(report.status.notAnswered), parseInt(report.status.partialAnswered)],
      });
    },
    async downloadExcel () {
      try {
        this.isDownloading = true
        const response = await api_diagnostic.downloadReport(this.report.id);

        if (response && response.data) {
          const blobURL = window.URL.createObjectURL(response.data)

          const temporalLink = document.createElement('a')
          temporalLink.style.display = 'none'
          temporalLink.href = blobURL
          temporalLink.setAttribute('download', `Diagnostic-Survey-${this.report.id}.xlsx`)

          document.body.appendChild(temporalLink)
          temporalLink.click()
          document.body.removeChild(temporalLink)
          window.URL.revokeObjectURL(blobURL)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isDownloading = false
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.diagnosticReports {
  &__header {
    margin: 1rem 0;
  }
  &__graph-container {
    background-color: white;
    padding: 1rem;
    text-align: center;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  }
  &__table {
    display: flex;
    max-width: 100%;
    .ui-table {
      width: 100%;
    }
  }
}
</style>